import { assign } from 'lodash';
import { MarketMetrics, MetricInfoJSON } from './Metrics';
import { MarkerType } from './Marker';
import { Geometry, GeoJsonGeometry, CoordinateBoundary } from '@realpage-da/ng-map';

export interface MarketJSON {
  id: number;
  name: string;
}

export interface MarketProperties {
  id: number;
  name: string;
  latitude: number;
  longitude: number;
}

export interface MarketProperty {
  PropertyId: string;
  PropertyName: string;
  MPFMarketName: string;
  MPFMKT: string;
  REGION: string;
  RegionIndex: string;
  RegionName: string;
  RegionType: string;
  Latitude: string;
  Longitude: string;
  MarketType: string;
  ExistingUnits: string;
  BoundingBox: string;
  GeoLocation: string;
  Units: string;
  ZoomLevel: string;
  position: string;
}

export interface MarketDetailJSON extends MarketJSON {
  metricdata: MetricInfoJSON[];
}

export class Market implements MarketJSON {
  id: number;
  name: string;
  position: string;
  type: string;

  static sortMarkets<T extends Market>(l: T, r: T, descending = false): number {
    return (+l.position - +r.position) * (descending ? -1 : 1);
  }

  constructor(json: MarketJSON) {
    if (!json) return this;
    assign(this, json);
  }

  updatePosition(type: MarkerType | string, position: string) {
    const markerType = typeof type === 'string' ? type : type.key;
    if (this.type === markerType && this.position === position) return;
    this.type = markerType;
    this.position = position;
  }

}

export class MarketDetail extends Market {
  metrics: MarketMetrics;

  constructor(json: MarketDetailJSON) {
    super(json);
    if (!json) return this;
    this.metrics = new MarketMetrics(json.metricdata);
  }
}

export interface MarketBounds {
  geometry: CoordinateBoundary;
  properties: MarketProperties;
}

export interface MarketImageJSON {
  response: string;
}

export interface MarketBoundsJSON {
  id: number;
  name: string;
  latitude: number;
  longitude: number;
  boundingBox: CoordinateBoundary;
  primaryState: string;
  urlSlug: string;
}

class RegionType {
  ZIP = 'ZIP';
  MARKET = 'MPFMKT';
  SUBMARKET = 'MPFSUBMKT';
}

export const REGION_TYPES = new RegionType();

export class Region {
  regionId: number;
  regionCode: number;
  regionName: string;
  regionType: string;

  constructor(json: any) {
    this.regionCode = parseInt(json.regionCode) || parseInt(json.regioncode);
    this.regionName = json.regionName || json.regionname;
    this.regionId = json.regionId || json.regionid;
    this.regionType = json.regionType || json.regiontype;
  }
}

export class RegionBoundary {
  geometry: Geometry;
  region: Region;

  constructor(json: any) {
    this.geometry = Geometry.fromCoordinateCollection(json.areas)
    this.region = new Region(json);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/model/Market.ts